import type { PresetFilter } from "@App/types";
import type { Dispatch } from "redux";
import type { Action } from "@App/state/actions/filter";
import { ActionType } from "@App/state/action-types";

export const setPresetFilter = (presetFilters: PresetFilter[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_PRESET_FILTER,
      payload: presetFilters,
    });
  };
};
